import Api from './Api'

const END_POINT = 'reports'

export default {
    purchases(params){
        let request = {
            params: params
        }
        return Api.get(`${END_POINT}/purchases`, request)
    },
    getPurchaseDetail(params){
        let request = {
            params: params
        }
        return Api.get(`${END_POINT}/purchases-detail`, request)
    },
    debts(params){
        let request = {
            params: params
        }
        return Api.get(`${END_POINT}/debts`, request)
    },
    sales(params){
        let request = {
            params: params
        }
        return Api.get(`${END_POINT}/sales`, request)
    },
    orders(params){
        let request = {
            params: params
        }
        return Api.get(`${END_POINT}/orders`, request)
    },
    cash(params){
        let request = {
            params: params
        }
        return Api.get(`${END_POINT}/cash`, request)
    },
    storeCreditNote (data) {
        return Api.post(`${END_POINT}/sales/canceled`, data);
    },

    getCreditNotes(params){
        let request = {
            params: params
        }
        return Api.get(`${END_POINT}/credit-notes`, request);
    },
}